import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/web3 apps.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const Web3Apps = () => {
  const heroData = {
    title: "Web3 & Decentralized Application Development",
    description: "Build the future of the internet with Web3 applications and decentralized platforms. We create secure, scalable blockchain solutions that empower users and redefine digital experiences.",
    image: img13,
    imageAlt: "Web3 Apps",
    features: [
      "Smart contract development",
      "Multi-chain support",
      "DeFi & NFT platforms",
      "Wallet integration",
      "Security audits",
      "Decentralized storage",
    ],
    pillars: [
      "Secure smart contracts that protect user assets and data",
      "Intuitive interfaces that make Web3 accessible to everyone",
      "Scalable architecture that handles growth and network demands",
    ],
  };

  const journeySteps = [
    {
      title: "Web3 Strategy & Blockchain Selection",
      description: "We analyze your use case, evaluate blockchain platforms (Ethereum, Polygon, Solana), and design your decentralized application architecture.",
      details: ["Use case analysis", "Blockchain evaluation", "Architecture design", "Token economics", "Consensus mechanism", "Scalability planning"],
    },
    {
      title: "Smart Contract Development",
      description: "Our blockchain experts develop, audit, and deploy secure smart contracts that power your Web3 application's core functionality.",
      details: ["Solidity development", "Contract architecture", "Security patterns", "Gas optimization", "Testing & auditing", "Deployment strategy"],
    },
    {
      title: "DApp Development",
      description: "We build intuitive Web3 interfaces with wallet integration, blockchain connectivity, and seamless user experiences for decentralized apps.",
      details: ["Frontend development", "Wallet integration", "Web3.js/Ethers.js", "IPFS integration", "Transaction handling", "State management"],
    },
    {
      title: "Testing & Launch",
      description: "Comprehensive security audits, testnet deployment, and mainnet launch ensure your Web3 app is secure, efficient, and ready for users.",
      details: ["Security audits", "Testnet deployment", "Load testing", "Mainnet launch", "Monitoring setup", "Community support"],
    },
  ];

  const capabilities = [
    {
      title: "DeFi Applications",
      content:
        "Decentralized finance apps including DEXs, lending platforms, yield farming, staking, and liquidity pool management solutions.",
    },
    {
      title: "NFT Platforms",
      content:
        "NFT marketplaces, minting platforms, collection managers, and blockchain-based digital asset management systems.",
    },
    {
      title: "DAO Development",
      content:
        "Decentralized autonomous organizations with governance mechanisms, voting systems, and treasury management capabilities.",
    },
    {
      title: "Web3 Gaming",
      content:
        "Play-to-earn games, metaverse applications, and blockchain gaming platforms with NFT integration and token economies.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "$10M+", label: "Total value locked (TVL)" },
      { value: "Zero", label: "Security breaches" },
      { value: "40%", label: "Gas cost optimization" },
    ],
    description: "We deliver Web3 applications that achieve strong user adoption, robust security, and efficient blockchain operations driving real-world value.",
  };

  const outcomesData = {
    description: "We create Web3 applications that combine cutting-edge blockchain technology with user-friendly experiences, enabling decentralized innovation and user empowerment.",
    outcomes: [
      "Multi-chain smart contract development",
      "Web3 wallet integration (MetaMask, WalletConnect)",
      "IPFS and decentralized storage integration",
      "Token creation and management (ERC-20, ERC-721)",
      "Gas optimization and transaction efficiency",
      "Security audits and best practices",
    ],
  };

  const whyChooseUs = [
    {
      title: "Blockchain Expertise",
      content:
        "Deep knowledge of multiple blockchain platforms, smart contract languages, and Web3 technologies ensures optimal solutions.",
    },
    {
      title: "Security First",
      content:
        "Rigorous smart contract audits, security best practices, and vulnerability testing protect your users and assets.",
    },
    {
      title: "User Experience",
      content:
        "We simplify Web3 complexity with intuitive interfaces that make blockchain technology accessible to all users.",
    },
    {
      title: "Full-Stack Web3",
      content:
        "From smart contracts to frontend DApps, we handle every aspect of Web3 development with end-to-end expertise.",
    },
  ];

  const faqs = [
    {
      q: "Which blockchain platform should I choose for my project?",
      a: "It depends on your requirements. Ethereum offers the largest ecosystem, Polygon provides low fees, Solana offers high speed, and BSC balances cost and features. We'll recommend the best fit based on your needs.",
    },
    {
      q: "How much does it cost to develop a Web3 application?",
      a: "Web3 development costs range from $30K for simple DApps to $200K+ for complex DeFi or NFT platforms. Costs include smart contract development, security audits, frontend DApp, and gas fees for deployment.",
    },
    {
      q: "Do you conduct security audits for smart contracts?",
      a: "Absolutely. We perform comprehensive security audits using automated tools and manual review, testing for vulnerabilities like reentrancy, overflow, and access control issues before mainnet deployment.",
    },
    {
      q: "Can you help with NFT marketplace development?",
      a: "Yes! We build complete NFT marketplaces with minting, buying/selling, auctions, royalties, IPFS storage, and integration with popular wallets and blockchain networks.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Web3 & DApp Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Web3 Development Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default Web3Apps;
